import { render, staticRenderFns } from "./OpenInzamelingen.vue?vue&type=template&id=573e42ce&scoped=true"
import script from "./OpenInzamelingen.vue?vue&type=script&lang=js"
export * from "./OpenInzamelingen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573e42ce",
  null
  
)

export default component.exports